export  const labour = [
    {
        id: '1',
        label: 'Engine',
        children: [
            {id: '1.1', label: 'Engine Tuning done ( 2.5 Hrs)'},
            {id: '1.2', label: 'Timing Chain ( 1.2 Hrs)'},
            {id: '1.3', label: 'Scanning', children: [
                    { id: '1.3.1', label: 'Engine Scanning done ( .30 hrs)' },
                ],
            },
        ],
    },
    {
        id: '2',
        label: 'Clutch',
        children: [
            {id: '2.1', label: 'Clutch Cable Replacement ( .5 Hrs)'},
            {id: '2.2', label: 'Overhauling', children: [
                    { id: '2.2.1', label: 'Cluth O/H  ( 2.5 Hrs)' },
                    { id: '2.2.2', label: 'Cluth System Resetted ( 1.2 Hrs)' },
                ],
            },
        ],
    },
    {
        id: '3',
        label: 'Manual Transmission',
        children: [
            {id: '3.1', label: 'Manual system checked ( .25 Hrs)'},
        ],
    },
    {
        id: '4',
        label: 'Cooling System',
        children: [
            {id: '4.1', label: 'Cooling system checked ( 1.5 Hrs)'},
            {id: '4.2', label: 'Cooling system corrected ( .3 Hrs)'},
        ],
    },
    // {
    //     id: '5',
    //     label: 'Exhause System',
    // },
    {
        id: '6',
        label: 'Suspension',
        children: [
            {id: '6.1', label: 'All suspension checked ( .25 Hrs)'},
            {id: '6.2', label: 'Removed and Refitted hub ( 3.5Hrs)'},
        ],
    },
    {
        id: '7',
        label: 'Gear Box',
        children: [
            {id: '7.1', label: 'Gear Box Upper Arm Bush Changed ( 1.2 Hrs)'},
            {id: '7.2', label: 'Gear Box Upper Arm Bush Changed ( 2.5 Hrs)'},
        ],
    },
    {
        id: '8',
        label: 'Brake',
        children: [
            {id: '8.1', label: 'Wheel Brake', children: [
                { id: '8.1.1', label: 'Wheel Brake Cable Replaced ( .25 Hrs)' },
                { id: '8.1.2', label: 'Wheel Brake cable checked ( 1.2 Hrs)' }
            ],
        },
        {id: '8.2', label: 'Brake Hub', children: [
            { id: '8.2.1', label: 'Hub Greasing Done ( 4.5 hrs)' },
        ],
    },
        ],
    },
    {
        id: '9',
        label: 'General Electric',
        children: [
            {id: '9.1', label: 'Head Light', children: [
                    { id: '9.1.1', label: 'Head Light bulb replaced ( .25 hrs)' },
                    { id: '9.1.2', label: 'Head Light Assy changed ( .3 hrs)' }
                ],
            },
            {id: '9.2', label: 'Rear Light', children: [
                { id: '9.2.1', label: 'Rear Light fuse corrected ( .2 Hrs)' },
                { id: '9.2.2', label: 'Rear light buld replaced ( .5 Hrs)' },
            ],
        },
        ],
        
    },
    {
        id: '10',
        label: 'Air Condition',
        children: [
            {id: '10.1', label: 'Air gas filling done ( 1.2 Hrs)'},
        ],
    },
    {
        id: '11',
        label: 'Body - Front',
        children: [
            {id: '11.1', label: 'Rear Lock Replaced ( .5 Hrs)'},
            {id: '11.2', label: 'Replaced Window handle ( .3 hrs)'},
        ],
    },
    {
        id: '12',
        label: 'Body - Rear',
        children: [
            {id: '12.1', label: 'Glass winder changed ( . 3 hrs)'},
            {id: '12.2', label: 'Rear View Mirror Replaced ( .5 Hrs)'},
        ],
    },
    {
        id: '13',
        label: 'Body - Center',
        children: [
            {id: '13.1', label: 'Door Lock Corrected ( .2Hrs)'},
            {id: '13.2', label: 'Door Lock Replaced ( .5 Hrs)'},
        ],
    },
  
];